import { z } from "zod";

import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";
import type { Badge } from "@rosette/ts/src/business/badge/Badge.js";


export const RevokeBadgeRequest = z.object({
    userPublicID: z.string(),
    badgePublicID: z.string(),
});
export type RevokeBadgeRequest = z.infer<typeof RevokeBadgeRequest>;


export const RevokeBadgeResponse = z.object({
    success: z.boolean(),
});
export type RevokeBadgeResponse = z.infer<typeof RevokeBadgeResponse>;


export async function revokeBadge(userPublicID: string, badge: Badge): Promise<void> {
    const request: RevokeBadgeRequest = {
        userPublicID,
        badgePublicID: badge.getID(),
    };
    const response = await fetchWithThrow("/api/admin/revokeBadge", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    RevokeBadgeResponse.parse(await response.json());
}
